var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{attrs:{"api-key":_vm.apiKey,"init":_vm.config},model:{value:(_vm.valueLocal),callback:function ($$v) {_vm.valueLocal=$$v},expression:"valueLocal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }